import { render, staticRenderFns } from "./OtherMerits.vue?vue&type=template&id=17b493da&"
import script from "./OtherMerits.vue?vue&type=script&lang=js&"
export * from "./OtherMerits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports